export class SerializerError extends Error {
  constructor(name: string, msg: string) {
    super(`[${name}]: ${msg}`);
  }
}
